import React, { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import { getMenus } from "../../services/menus";
import { menuJSON, planLogoJSON } from "../../util/header";
import PlanMessageDisplay from "../plan-message/plan-message-display";
import "./plan-header.scss";
import PlanNavigation from "./plan-navigation";
import { useSelector } from "../../store/store";
import { isLocal } from "../../util/constants";
import Rustle from "../misc/rustle";
import SkipLink from "../skip-link/skip-link";
import { isRustled } from "../../selectors/feature-flags";
import qs from "query-string";
import { setIsRustled } from "../../reducers/feature-flags-reducer";
import { getQueryStringParam } from "../../services/feature-flag-service";
import { FeatureParam } from "../../models/feature-flag";
import { useDispatch } from "react-redux";
import * as participantRepository from "../../repositories/participant";

function PlanHeader() {
  const { planId, empId, role } = useSelector((state) => state.session);
  const { planName, contractId, participantName } = useSelector(
    (state) => state.plan.info
  );
  const [menus, setMenus] = useState([]);
  const [planLogo, setPlanLogo] = useState({});
  const rustled = useSelector(isRustled);
  const query = window.location.search;
  const { disableNavbar } = qs.parse(query);
  const dispatch = useDispatch();

  const shouldLoadNavbar = !disableNavbar;
  React.useEffect(() => {
    dispatch(setIsRustled(getQueryStringParam(FeatureParam.RUSTLED)));
  }, [dispatch]);

  useEffect(() => {
    async function fetchPlanLogo() {
      if (planId && empId && role) {
        try {
          const data = await participantRepository.get(
            `/plans/${planId}/employees/${empId}/logo`,
            { role }
          );
          setPlanLogo(data);
        } catch (e) {}
      }
    }

    fetchPlanLogo();
  }, [empId, planId, role]);

  useEffect(() => {
    if (planId && empId && role) {
      fetchMenus();
    }

    async function fetchMenus() {
      if (window.location.hostname === "localhost") {
        setMenus(menuJSON);
        return;
      }

      const menuData = await getMenus(planId, empId, role);
      if (isLocal) {
        menuData.forEach((group) => {
          group.navigationLink = group.navigationLink?.replace(
            "secure05.pilot.principal.com/nq-participant/",
            "localhost.staging.principal.com/nq-participant/"
          );
          group.menuItems.forEach((item) => {
            item.navigationLink = item.navigationLink.replace(
              "secure05.pilot.principal.com/nq-participant/",
              "localhost.staging.principal.com/nq-participant/"
            );
          });
        });
      }
      setMenus(menuData);
    }
  }, [planId, empId, role]);

  if (window.location.pathname.includes("/landing")) {
    return null;
  }

  return (
    <>
      {rustled && <Rustle />}
      <SkipLink />
      {shouldLoadNavbar && (
        <div>
          <div className="plan-header bg-white">
            <div className="container display">
              <Plan
                planName={planName}
                participantName={participantName}
                contractId={contractId}
                planLogo={planLogo}
              />
            </div>

            <section className="nav-secondary-wrapper bg-white plan-navigation no-print">
              <nav className="container">
                <ul className="nav nav-secondary">
                  <PlanNavigation menus={menus} />
                </ul>
              </nav>
            </section>
          </div>
          <PlanMessageDisplay />
        </div>
      )}
    </>
  );
}

function Plan(props) {
  const { planName, participantName, contractId, planLogo } = props;
  return (
    <React.Fragment>
      <div className="row">
        <div className="col-md-10">
          <p className="h1 plan-name">{planName || <Skeleton width={300} />}</p>
          <p className="text-small account-identifier" data-hj-suppress>
            {participantName || <Skeleton width={100} />}
          </p>
          <p className="text-small account-identifier">
            Contract Number: {contractId || <Skeleton width={60} />}
          </p>
        </div>
        {planLogo.documentContent || isLocal ? (
          <div className="col-md-2 float-right custom-logo util-margin-top-10">
            <img
              className="custom-logo-image hidden-xs hidden-sm"
              src={`data:image/png;base64,${
                isLocal
                  ? planLogoJSON.documentContent
                  : planLogo.documentContent
              }`}
              alt=""
            />
          </div>
        ) : null}
      </div>
    </React.Fragment>
  );
}

export default PlanHeader;
